"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var vue_1 = __importDefault(require("vue"));
var ConditionalDisplay_1 = __importDefault(require("../../Mixins/ConditionalDisplay"));
var PredicateInput_1 = __importDefault(require("../../Mixins/PredicateInput"));
var SourceValue_1 = __importDefault(require("../../Mixins/SourceValue"));
exports.default = vue_1.default.extend({
    props: ['name', 'label', 'required', 'placeholder', 'readonly'],
    mixins: [ConditionalDisplay_1.default, PredicateInput_1.default, SourceValue_1.default],
    data: function () {
        var model = this.$root.$data;
        return {
            loading: false,
            internalReadonly: model.readOnly || this.readonly
        };
    },
    methods: {
        getFilePublicIds: function () {
            var root = this.$root;
            var children = root.getChildren(root);
            var publicIds = [];
            for (var _i = 0, children_1 = children; _i < children_1.length; _i++) {
                var child = children_1[_i];
                try {
                    var pubIds = child.getPublicIds();
                    publicIds.push.apply(publicIds, pubIds);
                }
                catch (_a) {
                    // Ignore
                }
            }
            return publicIds;
        },
        download: function () {
            var _this = this;
            this.loading = true;
            $.downloadAjax({
                url: "/Ged/DownloadFiles",
                method: "post",
                data: {
                    fileName: "Documents",
                    publicIds: this.getFilePublicIds()
                },
                done: function () {
                    _this.loading = false;
                }
            });
        }
    }
});



//////////////////
// WEBPACK FOOTER
// ./node_modules/ts-loader!./node_modules/vue-loader/lib/selector.js?type=script&index=0&bustCache!./_wwwsrc/js/Workflow/Components/Action/OzDownloadFiles.vue
// module id = 220
// module chunks = 0